module.exports = __webpack_public_path__ + "img/ready-for-minecraft-programming.e213e144.jpg";